import React from 'react';
import {MdOutlineStar} from 'react-icons/md';

export default function ReviewCard({item, showStars = true}) {
  const stars = item.stars ?? 5;

  return (
    <div>
      {showStars ? (
        <div className='stars'>
          {Array.from({length: stars}).map((_, i) => (
            <MdOutlineStar key={i} />
          ))}
        </div>
      ) : null}

      <span className='highlight'>{item.text}</span>
      <br />
      {item.author}
      {item.work ? `, ${item.work}` : null}
    </div>
  );
}
